module.exports = __webpack_public_path__ + "4e1d20bc53192f0ab48e6f0a657f9c16.pdf";